import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import Range from '@framework/ui/Organisms/Filters/FiltersPanel/Range/Range';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const RangeContainer = (props) => {
  const { filterName } = props;
  const { items: { filter } } = useBondsFiltersContext();
  const { getFiltersByFilterName } = useFiltersContext();
  const defaultRangeValue = filter[filterName];

  const filters = getFiltersByFilterName(BONDS_STORE_NAME, filterName);
  const isFilterExists = !!filters;

  const selectedRangeValue = isFilterExists ? filters.range : defaultRangeValue;
  const minValue = isFilterExists ? filters.minValue : defaultRangeValue.min;
  const maxValue = isFilterExists ? filters.maxValue : defaultRangeValue.max;

  return (
    <Range
      { ...props }
      selectedRangeValue={ selectedRangeValue }
      minValue={ minValue }
      maxValue={ maxValue }
    />
  );
};

export default RangeContainer;
